import { ChakraV3, dataAttr } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { FaRedo, FaUndo } from 'react-icons/fa';

interface Props {
  editor: Editor;
}

export const UndoRedo = (props: Props) => {
  const { editor } = props;

  const items = [
    {
      icon: FaUndo,
      title: 'Undo',
      action: () => editor.chain().focus().undo().run(),
      isActive: () => false,
      isDisabled: () => !editor.can().undo(),
    },
    {
      icon: FaRedo,
      title: 'Redo',
      action: () => editor.chain().focus().redo().run(),
      isActive: () => false,
      isDisabled: () => !editor.can().redo(),
    },
  ];

  return (
    <ChakraV3.HStack gap={1}>
      {items.map((item) => (
        <ChakraV3.IconButton
          key={item.title}
          aria-label={item.title}
          variant='ghost'
          size='xs'
          rounded='md'
          onClick={item.action}
          {...{ 'data-active': dataAttr(item.isActive()) }}
          disabled={item.isDisabled()}
        >
          <item.icon />
        </ChakraV3.IconButton>
      ))}
    </ChakraV3.HStack>
  );
};
